export default __webpack_public_path__ + "static/homepage-potato-8f6c939bafb4d0a3ed9f35866ea6bd35.jpg";